export default __webpack_public_path__ + "static/media/dermaheal3.b7163e33.jpg";